import { Injectable } from '@angular/core';
import { ACLService } from '@delon/acl';

@Injectable({
  providedIn: 'root'
})
export class ACLWrapperService {

  scopeRoleObject: any = { 'SCOPE': [] };
  // TODO:get param from API
  mockScopeArray: string[] = [
    'user-management_/user-management/list_rty',
    'calendar_/calendar/schedule_create',
    '/reference-data/list_create',
    '/reference-values/list_create'
  ];
  scopeString: any[] = [];
  constructor(public aclSrv: ACLService) {
    this.aclSrv.setFull(false);
    this.createScopeObject(this.mockScopeArray);
  }

  private setAbility(ablities: string[]) {
    this.aclSrv.setAbility(ablities);
  }

  private createScopeObject(arr: string[]) {
    for (const i of arr) {
      const tempArr = i.split('_');
      const strArr = tempArr[0].split('/');
      if (strArr.length > 1) {
        this.scopeRoleObject['SCOPE'].push({ 'module': strArr[1], 'method': tempArr[0], 'type': tempArr[1] });
      } else {
        this.scopeRoleObject['SCOPE'].push({ 'module': tempArr[0], 'method': tempArr[1], 'type': tempArr[2] });
      }
    }
    for (const j of this.scopeRoleObject['SCOPE']) {
      this.scopeString.push(j['method'].toLowerCase() + '_' + j['type'].toLowerCase());
    }
    this.setAbility(this.scopeString);
  }

}
